import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss']
})
export class MainContainerComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/main-container/main-container.component.ts